import { SurveysParticipantViewsPage } from "@/pages/talent/surveys/SurveysParticipantViewsPage.tsx";

export const SurveyRequestsPage = () => {
  return <SurveysParticipantViewsPage mode="requests" />;
};
